module.exports = __webpack_public_path__ + "static/stage_high-19902fdd3364da167abded0f22f7b786.jpg";